import { optionSubcategory_roomPreferences } from './roomPreferencesSubCategory.locstring.json';
import RoomPreferencesOption from 'owa-calendar-room-preferences-option/lib/RoomPreferencesOption';
import { OptionSubCategory } from 'owa-options-core';
import { lazyInitRoomPreferencesSetting } from 'owa-calendar-room-preferences-option';

const roomPreferencesSubCategory: OptionSubCategory = {
    key: 'roomPreference',
    titleStringKey: optionSubcategory_roomPreferences,
    options: [RoomPreferencesOption],
    onSelected: () => {
        return lazyInitRoomPreferencesSetting.importAndExecute();
    },
};

export default roomPreferencesSubCategory;
